function isAvailableProduct (productId, stock) {
  for (var i = 0; i < stock.length; i++) {
    if (stock[i].product_id === productId) {
      if (stock[i].available_quantity > 0) {
        return true
      }
    }
  }
  return false
}

function findMainAddress (addresses) {
  for (var i in addresses) {
    if (addresses[i].is_default === true) {
      return i
    }
  }
}

function isExistCreditCard (cards) {
  for (var i in cards) {
    if (cards[i].is_main === true && (cards[i].status === '검증됨' || cards[i].status === '검증전')) {
      return i
    }
  }
}

function isCellPhone (p) {
      p = p.split('-').join('')
      var regPhone = /^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/
      return regPhone.test(p)
}

export { isAvailableProduct, findMainAddress, isExistCreditCard, isCellPhone }



// WEBPACK FOOTER //
// ./src/modules/modules.js